<template>
  <div>
    <div v-if="loading" class="align-center d-flex justify-center" style="height: 350px">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <highcharts v-else :options="chartOptions" style="height: 350px !important" />
  </div>
</template>

<script>
  import DashboardQuantitativosService from '../../../../services/DashboardQuantitativosService';

  export default {
    name: 'GraficoEntidades',

    props: {
      entidade: {
        type: Object,
        required: true
      },
      filtrosAtivos: {
        type: Object,
        default: () => ({})
      },
      tipo: {
        type: String,
        validator: (value) => ['regional', 'municipio', 'material', 'uc', 'tipounidade'].includes(value)
      }
    },

    data() {
      return {
        dados: [],
        loading: false,
        chartOptions: {
          chart: {
            type: 'column',
            backgroundColor: 'white',
            style: { fontFamily: 'Muli' }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            categories: [],
            crosshair: true,
            labels: {
              rotation: 0,
              style: {
                fontSize: '11px'
              }
            },
            gridLineWidth: 0,
            lineWidth: 1,
            tickWidth: 1
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Quantidade'
            },
            gridLineWidth: 1,
            lineWidth: 0,
            tickWidth: 0
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px"><b>{point.key}</b></span><br>',
            pointFormatter: function () {
              const value = Number(this.y).toLocaleString('pt-BR', {
                maximumFractionDigits: 2
              });
              return '<span style="color:' + this.color + '">Qtd</span>: <b>' + value + '</b><br/>';
            },
            shared: true,
            useHTML: true,
            backgroundColor: 'rgba(255,255,255,0.95)',
            borderColor: '#ccc',
            style: { color: '#333', fontSize: '12px' }
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: false,
                formatter: function () {
                  return Number(this.y).toLocaleString('pt-BR', {
                    maximumFractionDigits: 2
                  });
                }
              }
            }
          },
          legend: {
            enabled: false
          },
          exporting: {
            enabled: true,
            menuItemDefinitions: {
              viewFullscreen: { text: 'Tela Cheia' },
              downloadPNG: { text: 'Baixar PNG' },
              downloadJPEG: { text: 'Baixar JPEG' },
              downloadSVG: { text: 'Baixar SVG' }
            },
            buttons: {
              contextButton: {
                menuItems: ['viewFullscreen', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadSVG']
              }
            }
          },
          series: []
        }
      };
    },

    mounted() {
      this.getDados();
    },

    methods: {
      getDados() {
        this.loading = true;

        const serviceMethods = {
          regional: () => DashboardQuantitativosService.getPorRegional(this.entidade.key, this.filtrosAtivos),
          municipio: () => DashboardQuantitativosService.getPorMunicipio(this.entidade.key, this.filtrosAtivos),
          material: () => DashboardQuantitativosService.getPorMaterial(this.entidade.key, this.filtrosAtivos),
          uc: () => DashboardQuantitativosService.getPorUnidadeConsumidora(this.entidade.key, this.filtrosAtivos),
          tipounidade: () => DashboardQuantitativosService.getPorTipoUnidade(this.entidade.key, this.filtrosAtivos)
        };

        const serviceMethod = serviceMethods[this.tipo];

        serviceMethod()
          .then(({ data }) => {
            this.dados = data.map((item, index) => ({
              id: index,
              nome: item[this.tipo] || item.nome,
              qtd: Number(item.qtd) || 0
            }));

            this.$nextTick(() => {
              this.atualizarGrafico();
            });
          })
          .catch((err) => {
            console.error('Erro ao buscar dados:', err);
            this.$toast.error(`Erro ao buscar dados do gráfico.`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },

      atualizarGrafico() {
        if (!this.dados || this.dados.length === 0) return;

        let dadosProcessados = [...this.dados];

        if (this.tipo === 'municipio') {
          dadosProcessados = dadosProcessados.slice(0, 10);
        }

        const categories = dadosProcessados.map((item) => item.nome);
        const seriesData = dadosProcessados.map((item) => item.qtd);

        this.chartOptions.xAxis.categories = categories;

        this.chartOptions.xAxis.labels.rotation = categories.length > 10 ? -45 : 0;

        this.chartOptions.plotOptions.column.dataLabels.enabled = categories.length <= 15;

        this.chartOptions.series = [
          {
            name: this.entidade.label,
            data: seriesData,
            color: this.$vuetify.theme.currentTheme.primary || '#1976D2'
          }
        ];
      }
    },

    watch: {
      entidade: {
        handler() {
          this.getDados();
        },
        deep: true
      }
    }
  };
</script>
